import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	sectionHeading: {
		id: 'fastshift.organization-details.dc-instances.heading',
		defaultMessage: 'Data Center instances',
		description: 'Heading above the Data Center instances table for an organization.',
	},
	tableCaption: {
		id: 'fastshift.organization-details.dc-instances.table-caption',
		defaultMessage: 'Data Center instances connected to this organization',
		description: 'Accessible caption for the organization Data Center instances table.',
	},
	sourceColumnHeading: {
		id: 'fastshift.organization-details.dc-instances.source-column-heading',
		defaultMessage: 'Data Center source',
		description: 'Column heading for the Data Center instance product and URL.',
	},
	connectionColumnHeading: {
		id: 'fastshift.organization-details.dc-instances.connection-column-heading',
		defaultMessage: 'Connection',
		description: 'Column heading for the Data Center instance connection status.',
	},
	errorMessage: {
		id: 'fastshift.organization-details.dc-instances.error-message',
		defaultMessage: 'We’re unable to retrieve the data about your Data Center instances.',
		description: 'Error message shown when Data Center instances cannot be loaded.',
	},
	jiraProduct: {
		id: 'fastshift.organization-details.dc-instances.product.jira',
		defaultMessage: 'Jira',
		description: 'Product label for a Jira Data Center instance.',
	},
	confluenceProduct: {
		id: 'fastshift.organization-details.dc-instances.product.confluence',
		defaultMessage: 'Confluence',
		description: 'Product label for a Confluence Data Center instance.',
	},
	unknownProduct: {
		id: 'fastshift.organization-details.dc-instances.product.unknown',
		defaultMessage: 'Unknown product',
		description: 'Fallback product label for an unrecognized Data Center instance product.',
	},
	connectionConnected: {
		id: 'fastshift.organization-details.dc-instances.connection.connected',
		defaultMessage: 'Connected',
		description: 'Connection status for a connected Data Center instance.',
	},
	connectionInitialized: {
		id: 'fastshift.organization-details.dc-instances.connection.initialized',
		defaultMessage: 'Initialized',
		description: 'Connection status for an initialized Data Center instance.',
	},
	connectionRegenerating: {
		id: 'fastshift.organization-details.dc-instances.connection.regenerating',
		defaultMessage: 'Regenerating',
		description: 'Connection status for a Data Center instance regenerating its connection.',
	},
	connectionDisconnected: {
		id: 'fastshift.organization-details.dc-instances.connection.disconnected',
		defaultMessage: 'Disconnected',
		description: 'Connection status for a disabled Data Center instance connection.',
	},
	connectionExpired: {
		id: 'fastshift.organization-details.dc-instances.connection.expired',
		defaultMessage: 'Expired',
		description: 'Connection status for an expired Data Center instance connection.',
	},
	connectionInterrupted: {
		id: 'fastshift.organization-details.dc-instances.connection.interrupted',
		defaultMessage: 'Interrupted',
		description: 'Connection status for an interrupted Data Center instance connection.',
	},
	connectionFailed: {
		id: 'fastshift.organization-details.dc-instances.connection.failed',
		defaultMessage: 'Failed',
		description: 'Connection status for a failed Data Center instance connection.',
	},
	connectionOffline: {
		id: 'fastshift.organization-details.dc-instances.connection.offline',
		defaultMessage: 'Offline',
		description: 'Connection status for an offline Data Center instance connection.',
	},
	connectionUnknown: {
		id: 'fastshift.organization-details.dc-instances.connection.unknown',
		defaultMessage: 'Unknown',
		description: 'Fallback connection status for an unrecognized Data Center instance status.',
	},
});
